
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forestry-admission",
      function () {
        return require("private-next-pages/forestry-admission/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forestry-admission"])
      });
    }
  